

































































































































































































































































































import Vue from "vue";
import * as R from "ramda";
import USER from "@/graphql/users/User.gql";
import PROJECTS from "@/graphql/projects/Projects.gql";
import PasswordDialog from "@/components/PasswordDialog.vue";
import {
  Projects_projects_edges,
  User,
  Projects_projects_edges_node,
  User_user,
  Projects_projects
} from "../api-types";
import { ApolloQueryResult } from "apollo-client";
import { interfaces } from "mocha";
import forEach from "ramda/es/forEach";

interface Project extends Projects_projects_edges_node {
  [key: string]: any;
}

export default Vue.extend({
  components: { PasswordDialog },
  apollo: {
    user: {
      query: USER,
      variables() {
        return {
          id: this.$auth.user().id
        };
      },
      result({ data }: ApolloQueryResult<User>) {
        this.$store.commit("setToolIds", data.user!.toolIds);
      }
    },
    projects: {
      query: PROJECTS
    }
  },
  data() {
    return {
      drawer: true,
      user: null as User_user | null,
      openPasswordDialog: false,
      projects: null as Projects_projects | null
      // user: undefined as undefined | User_user
    };
  },
  methods: {
    isDisabled: function(projectEdge: Projects_projects_edges, app: string) {
      const project: Project | null = projectEdge!.node;
      return project![app].active &&
        this.user!.toolIds.includes(project![app].id)
        ? false
        : true;
    },
    hasAccess: function(projectEdge: Projects_projects_edges) {
      let hasTool = false;
      Object.entries(projectEdge!.node!).forEach(([__, v]) => {
        if (v && this.user!.toolIds.includes(v.id) && v.active) {
          hasTool = true;
          return;
        }
      });
      return hasTool;
    },
    onLogoClick: function() {
      const path = "/projekte/uebersicht";
      if (this.$router.currentRoute.path !== path) this.$router.push(path);
    }
  }
});
